module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "p28",
      "title": "28"
    }
  }, [_c('p', {
    staticClass: "icon"
  }, [_c('span', {
    staticClass: "grey"
  }, [_vm._v("[")]), _vm._v(" QUICK PREP "), _c('span', {
    staticClass: "grey"
  }, [_vm._v("]")])]), _vm._v(" "), _c('h2', {
    staticClass: "recipetitle",
    attrs: {
      "id": "apple_crisp_refrigerator_oatmeal"
    }
  }, [_vm._v("Apple Crisp Refrigerator Oatmeal")]), _vm._v(" "), _c('p', {
    staticClass: "recipetime"
  }, [_c('span', {
    staticClass: "yield_black"
  }, [_vm._v("1 serving")]), _vm._v(" "), _c('span', {
    staticClass: "separater"
  }, [_vm._v("|")]), _vm._v(" Prep Time: 5 Minutes "), _c('span', {
    staticClass: "separater"
  }, [_vm._v("|")]), _vm._v(" Start to Finish: 8 Hours 5 Minutes")]), _vm._v(" "), _c('p', {
    staticClass: "dot"
  }, [_vm._v("•••")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient_head"
  }, [_vm._v("OATMEAL")]), _vm._v(" "), _c('ul', {
    staticClass: "ingredient1"
  }, [_c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("¼")]), _vm._v(" cup old-fashioned oats")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("1")]), _vm._v(" container (6 oz) apple crisp low-fat yogurt")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("1")]), _vm._v(" teaspoon chia seed, if desired")])]), _vm._v(" "), _c('p', {
    staticClass: "ingredient_head"
  }, [_vm._v("TOPPINGS, IF DESIRED")]), _vm._v(" "), _c('ul', {
    staticClass: "ingredient1"
  }, [_c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("¼")]), _vm._v(" cup chopped Granny Smith apple")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("⅛")]), _vm._v(" teaspoon ground cinnamon")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("2")]), _vm._v(" tablespoons chopped walnuts")])]), _vm._v(" "), _c('p', {
    staticClass: "recipeprocedure"
  }, [_c('span', {
    staticClass: "stepnum"
  }, [_vm._v("1")]), _vm._v(" In half-pint canning jar (or other resealable container), place oats. Top with yogurt and chia seed; carefully stir to mix thoroughly. Cover; refrigerate about 8 hours.")]), _vm._v(" "), _c('p', {
    staticClass: "recipeprocedure"
  }, [_c('span', {
    staticClass: "stepnum"
  }, [_vm._v("2")]), _vm._v(" Sprinkle with toppings before serving.")]), _vm._v(" "), _c('p', {
    staticClass: "recipe_info"
  }, [_c('span', {
    staticClass: "nutr_bold"
  }, [_vm._v("1 Serving:")]), _vm._v(" Calories 240; Total Fat 3g (Saturated Fat 1g, Trans Fat 0g); Cholesterol 10mg; Sodium 90mg; Total Carbohydrate 47g (Dietary Fiber 2g); Protein 7g "), _c('span', {
    staticClass: "nutr_bold"
  }, [_vm._v("Exchanges:")]), _vm._v(" 1½ Starch, 1½ Other Carbohydrate, ½ Fat "), _c('span', {
    staticClass: "nutr_bold"
  }, [_vm._v("Carbohydrate Choices:")]), _vm._v(" 3")]), _vm._v(" "), _c('p', {
    staticClass: "recipe_note"
  }, [_c('span', {
    staticClass: "tips"
  }, [_vm._v("Fresh Idea")]), _vm._v(" Check out chia seed. It is an unprocessed whole grain with a mild nutty flavor. It helps to thicken dishes, like the oatmeal here. Chia seed’s thickening power is also great in smoothies.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c67d330","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/p028.vue
// module id = 129
// module chunks = 0